import { useMenuRegistrationStore } from '../../hooks';
import { MenuRegistrationModalView } from '../../components/MenuRegistrationModalView';

export const MenuRegistrationModal = () => {
  const registrationStore = useMenuRegistrationStore();

  return <MenuRegistrationModalView {...registrationStore} />;
};
